import React, { useState } from "react";
import {Container,Image} from "react-bootstrap";
import {Link} from "react-router-dom";
import {ViewOffSlashIcon,EyeIcon,ArrowLeftIcon,} from "../../assets/icons";
// import logoBlack from "../../assets/images/logo/logo-dark.png";
import LoginLogo from "../../assets/images/login/shapes/login-logo.png";
import "./Styles/Login.css";
// import { useDispatch, useSelector } from "react-redux";
import CommonButton from "../../components/commonButton";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
import { routes } from "../../routes/PageRoutes";

const ResetPassword = () => {
  // const [showToast, setShowToast] = useState(false);
  const [newPwShowEyeIcon,setNewPwShowEyeIcon] = useState(false);
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  // const [toastMessage, setToastMessage] = useState("");
  // const [toastVariant, setToastVariant] = useState("toast-success");
  // const dispatch = useDispatch();
  // const { status, error } = useSelector((state) => state.auth);
  // const navigate = useNavigate();

  return (
    <>
      <Container fluid="xxl" className="mx-auto px-4">
        <div className="d-flex align-items-center justify-content-center py-4  login-content">
          <div className="position-relative w-100 py-4 login-sub-content">
            <div className="bg-white rounded-2 p-5 common-shadow login-card">
              <h1 className="fs-5 d-flex align-content-center justify-content-center mb-4">
                <span className=" text-decoration-none  d-inline-block">
                  <Image src={LoginLogo} alt="Site-Logo" />
                </span>
              </h1>
              <div className="mb-4 welcome-content">
                <h4 className="mb-1 fw-medium text-start">
                  Reset Password
                </h4>
                <p className="text-start">
                  Your new password must be different from previously used passwords
                </p>
              </div>

                  <div className="mb-4">
                    <CommonFormLabel title="New Password" />
                    <div className="position-relative">
                    <Input
                      id="new_password"
                      name="new_password"
                      type="password"
                      placeholder="············"
                      // onChange={handleChange}
                      className={`shadow-none`}
                      // className={`shadow-none ${touched.email && errors.email ? 'error' : 'correct'}`}
                    />
                     <div className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer">
                        {newPwShowEyeIcon === false ? (
                          <ViewOffSlashIcon
                            width={20}
                            height={20}
                            color="#444050"
                            strokeWidth="1.5"
                            //  className={touched.password && errors.password ? 'error' : 'correct'}
                            onClick={() => setNewPwShowEyeIcon(true)}
                          />
                        ) : (
                          <EyeIcon
                            width={20}
                            height={20}
                            color="#444050"
                            strokeWidth="1.5"
                            // className={`${touched.password && errors.password ? 'error' : 'correct'}`}
                            onClick={() => setNewPwShowEyeIcon(false)}
                          />
                        )}
                      </div>
                      </div>
                  </div>
                  <div className="mb-4">
                    <CommonFormLabel title="Confirm Password" />
                    <div className="position-relative">
                      <Input
                        id="password"
                        name="password"
                        // type="password"
                        type={`${showEyeIcon ? "text" : "password"}`}
                        placeholder="123@123"
                        // onChange={handleChange}
                        className={`shadow-none`}
                        // className={`shadow-none ${touched.password && errors.password ? 'error' : 'correct'}`}
                      />
                      <div className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer">
                        {showEyeIcon === false ? (
                          <ViewOffSlashIcon
                            width={20}
                            height={20}
                            color="#444050"
                            strokeWidth="1.5"
                            //  className={touched.password && errors.password ? 'error' : 'correct'}
                            onClick={() => setShowEyeIcon(true)}
                          />
                        ) : (
                          <EyeIcon
                            width={20}
                            height={20}
                            color="#444050"
                            strokeWidth="1.5"
                            // className={`${touched.password && errors.password ? 'error' : 'correct'}`}
                            onClick={() => setShowEyeIcon(false)}
                          />
                        )}
                      </div>
                    </div>
                  </div>


              <CommonButton title="Set New Password" type="submit" className="w-100 btn-primary primary-shadow"/>
                <div className="welcome-content d-flex align-items-center justify-content-center gap-2 mt-4">
                   <Link to={routes.login} className="text-decoration-none d-flex align-items-center justify-content-center link-title">
                    <ArrowLeftIcon
                        width={22}
                        height={22}
                        color="#9F2F48"
                        strokeWidth="2.2"
                      />
                      Back to login
                   </Link>
                </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ResetPassword;
